import React from 'react';

/**
 * Creates the confirmation ban user form
 * @param content
 * @param type
 * @returns {XML}
 */
const banUserConfirmation = ( { content, type } ) => {
	let title = type === '' ?
			<p>You are about to ban the user <strong>{ content.username }</strong> (id:{ content.userid })</p> :
			<p>You are about to perform the following actions concerning the user <strong>{ content.username }</strong> (id:{ content.userid })</p>,
		form = [],
		field = [],
		lines_el = [],
		li = null,
		option = null,
		key_counter = 0;

	content.message.map( ( line ) => {
		field = null;
		let data = line.data,
		label = data[ 'label' ] ? data[ 'label' ].replace( /<br\s+[/]?\s*>/g, '' ).replace( /\s*:\s*$/, '' ) : null;

		key_counter++;

		switch( line.type ) {
			case 'text':
				lines_el = [];
				if( typeof data[ 'text' ] !== 'string' && data[ 'text' ].length > 0 ) {
					data[ 'text' ].map( ( text ) => {
						// Cleaning
						text = text.replace( /<br\s+[/]?\s*>/, '' );
						let el = ( <span className="text" key={ key_counter } >{ text }<br/></span> );
						lines_el.push( el );
						key_counter++;
					} )
				} else {
					lines_el = data[ 'text' ].replace( /<br\s+[/]?\s*>/g, '' );
				}

				field = <p key={ key_counter } className="styled-field">{ lines_el }</p>;
				form.push( field );
				break;

			case 'input':
				field = <p key={ key_counter } className="field styled-field"><label className="field-label">{ label }: <input name={ line[ 'name' ] } required={ data[ 'required' ] ? 'required' : false } placeholder={ data[ 'placeholder' ] } defaultValue={ data[ 'value' ] ? data[ 'value' ] : null }/></label></p>;
				form.push( field );
				break;

			case 'select':
				lines_el = [];
				for( option in data[ 'options' ] ) {
					if( data[ 'options' ].hasOwnProperty( option ) ) {
						li = <option key={ key_counter + '_' + option } value={ option }>{ data[ 'options' ][ option ] }</option>;
						lines_el.push( li );
					}
				}
				field = <p key={ key_counter } className="styled-field">{ label }: <select name={ line[ 'name' ] } defaultValue={ data[ 'value' ] ? data[ 'value' ] : null }>{ lines_el }</select></p>;
				form.push( field );
				break;
		}
	} );

	return (
		<div className="banUserForm" >
			{ title }
			{ form }
			<p>Please confirm your intentions</p>
		</div>
	);
};


export default banUserConfirmation;



// WEBPACK FOOTER //
// ./src/components/modtools/banUserConfirmation.js